export { default } from './NewsIndex';
